import { WEB_COMPONENT_LICENSE_MONTHLY_LICENSE_TRIAL_SUBFORM } from '../../webcomponents.constants';
import { LicenseMonthlyLicenseTrialSubFormWebComponent } from './component/LicenseMonthlyLicenseTrialSubFormWebComponent';

export { LicenseMonthlyLicenseTrialSubFormWebComponent };

window.customElements.define(
  WEB_COMPONENT_LICENSE_MONTHLY_LICENSE_TRIAL_SUBFORM,
  LicenseMonthlyLicenseTrialSubFormWebComponent
);
